import React from 'react'

const DataTableEmptyState = () => {
  return (
    <> 
       <div className='px-4 pt-5 text-center'>
             <img src="/assets/images/emptyStateTable.png" alt="" className='mb-3' />
             <p className='text-color font-13 font-weight-normal'>Empty</p>
        </div>
    </>
  )
}

export default DataTableEmptyState
